<template>
  <div class="p-0" @click="driveIconClicked">
    <span v-if="oauthToken">
      <img src="/common_images/icons/google_drive_tile.png" alt="Google drive icon" class="mar-r-2" height="16" width="20" />
      <span>{{ $t('Google Drive') }}</span>
    </span>
    <iframe v-else ref="ifr" height="40" width="100%" scrolling="no" :src="iframeSrc" />
  </div>
</template>

<script>
import BaseComponent from '@/components/commentsNew/BaseComponent'
import GooglePickerMixin from '@/components/attachments/GooglePickerMixin'

export default {
  name: 'AttachmentOptionGooglePicker',
  extends: BaseComponent,
  mixins: [GooglePickerMixin],
  data () {
    return {
      boundMessageHandler: this.messageHandler.bind(this),
      iframeQueryOptions: {
        linkColor: '#23646464',
        fontSize: '16px',
        iconSize: 20
      },
      pickerApiLoaded: false
    }
  }
}
</script>

<style scoped>
iframe {
  border: 0;
}
</style>
